import { brandColors } from '@/styles/sunrunTheme.styles';
import type { TextEffectCF } from '@/types';

import RainbowSlideVertical from './RainbowSlide';
import Typewriter from './Typewriter';

export const textEffectColorMap: Record<
  NonNullable<TextEffectCF['fields']['colors']>[number],
  string
> = {
  'Charge Blue': brandColors.chargeBlue,
  'Charge Red': brandColors.chargeRed,
  'Charge Yellow': brandColors.chargeYellow,
};

export const isTextEffectEntry = (entry: unknown): entry is TextEffectCF => {
  // biome-ignore lint/suspicious/noExplicitAny: Automated migration to Biome
  return (entry as any)?.sys?.contentType?.sys?.id === 'textEffect';
};

export const textEffectRenderer = (entry: TextEffectCF) => {
  switch (entry.fields.effectType) {
    case 'Rainbow slide (vertical)':
      return <RainbowSlideVertical entry={entry} />;
    case 'Typewriter':
      return <Typewriter entry={entry} />;
    default:
      return null;
  }
};
